import { PnlBenchmark } from 'utils/PnL';
import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { WidgetConfigWithLegends } from 'widgets/WidgetLegend/WidgetConfigWithLegends';

export type PortfolioPlAggregationType = 'combined' | 'buys' | 'sells';

export interface PortfolioPlWidgetLegends {
    hideRealizedPnl: boolean;
    hideUnrealizedPnl: boolean;
    hideTotalPnl: boolean;
    hideIndexPnl: boolean;
    leavesHideBuys: boolean;
    leavesHideSells: boolean;
    leavesHideNet: boolean;
}

export interface PortfolioPlWidgetConfigState
    extends WidgetConfigWithHideableToolbar,
        WidgetConfigWithLegends<PortfolioPlWidgetLegends> {
    aggregationType: PortfolioPlAggregationType;
    benchmarkType: PnlBenchmark;
    index: string;

    /*
     * Hide the leaves companion chart
     */
    leavesHidden: boolean;
    /*
     * Collapse the leaves companion chart
     */
    leavesCollapsed: boolean;
}

export const initialPortfolioPlConfigState: PortfolioPlWidgetConfigState = {
    aggregationType: 'combined',
    benchmarkType: PnlBenchmark.Arrival,
    index: '',
    hideRealizedPnl: false,
    hideUnrealizedPnl: false,
    hideTotalPnl: false,
    hideIndexPnl: false,
    hideToolbar: false,
    leavesHidden: false,
    leavesCollapsed: false,
    leavesHideBuys: false,
    leavesHideSells: false,
    leavesHideNet: false,
    hideRealizedPnlLegend: false,
    hideUnrealizedPnlLegend: false,
    hideTotalPnlLegend: false,
    hideIndexPnlLegend: false,
    leavesHideBuysLegend: false,
    leavesHideSellsLegend: false,
    leavesHideNetLegend: false,
};
